import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CocaColaValuesGameHccbRoutingModule } from './coca-cola-values-game-hccb-routing.module';
import { CocaColaHccbService } from './coca-cola-hccb.service';
import { CocaColaValuesGameHccbComponent } from './coca-cola-values-game-hccb.component';
import { ValuesGamePlayerCoreModule } from '../talent-litmus-core/values-game-player-core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [CocaColaValuesGameHccbComponent],
  imports: [
    CommonModule,
    SharedModule,
    MatTabsModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    ReactiveFormsModule,
    ValuesGamePlayerCoreModule,
    CocaColaValuesGameHccbRoutingModule,
  ],
  providers: [CocaColaHccbService],
})
export class CocaColaValuesGameHccbModule {}
